<template>
    <div>
        <template v-if="!valuationGenerated && !isLoading">
            <valuation-failed />
        </template>
        <template v-else>
            <div class="new_banner button_new_cash_offer">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8 col-md-12">
                            <div
                                class="new_banner_content_box"
                                v-if="valuationGenerated && !isLoading"
                            >
                                <div class="new_banner_content_title">
                                    <h1>Your Home Value</h1>
                                    <p>
                                        Based on Automated Valuation Method
                                        (AVM)
                                    </p>
                                    <p>
                                        <span
                                            ><img
                                                src="/valuation/final_offer/image/location_new.png"
                                                class="img-fluid"
                                                alt="location" /></span
                                        >{{ selectedAddress }}
                                    </p>
                                </div>
                                <div class="new_banner_content_price">
                                    <h2>
                                        ${{
                                            cashOfferValuation.average
                                                | fixedPrice
                                                | numberWithCommas
                                        }}
                                    </h2>
                                    <small
                                        >Approximate value based on similar
                                        homes in the area.</small
                                    >
                                </div>
                                <div class="new_banner_content_slide">
                                    <ul class="slider_title">
                                        <li>LOW</li>
                                        <li>AVERAGE</li>
                                        <li>HIGH</li>
                                    </ul>
                                    <div class="slider_bar">
                                        <div class="slider_bar_ball"></div>
                                    </div>
                                    <ul class="slider_price">
                                        <li>
                                            ${{
                                                cashOfferValuation.min
                                                    | fixedPrice
                                                    | numberWithCommas
                                            }}
                                        </li>
                                        <li>
                                            ${{
                                                cashOfferValuation.average
                                                    | fixedPrice
                                                    | numberWithCommas
                                            }}
                                        </li>
                                        <li>
                                            ${{
                                                cashOfferValuation.max
                                                    | fixedPrice
                                                    | numberWithCommas
                                            }}
                                        </li>
                                    </ul>
                                    <small
                                        >*An accurate cash offer will be
                                        provided after viewing the
                                        property</small
                                    >
                                </div>
                                <div class="new_banner_content_button">
                                    <a
                                        href="javascript:void(0)"
                                        @click="getMyCashOffer"
                                        >Get Our Instant Cash Offer</a
                                    >
                                    <a
                                        href="javascript:void(0)"
                                        @click="expertValuation"
                                        >Schedule an appointment</a
                                    >
                                </div>
                            </div>
                            <div
                                class="new_banner_content_box"
                                v-if="isLoading"
                            >
                                <div
                                    class="mb-4 mb-md-5"
                                    data-aos="zoom-in"
                                    data-aos-duration="1000"
                                >
                                    <img
                                        src="/images/loader/Spin-1s-200px.gif"
                                        width="42"
                                        alt=""
                                    />
                                    <span
                                        class="pl-2 font-weight-bold"
                                        style="font-size: 20px"
                                        >Please Wait! Calculating offer.</span
                                    >
                                </div>
                            </div>
                            <div
                                class="new_banner_content_box"
                                v-if="!valuationGenerated && !isLoading"
                            >
                                <div class="col-lg-12 mb-3" v-if="!isLoading">
                                    <div class="mb-4">
                                        <h4
                                            class="mb-2 text-primary font-weight-bold"
                                        >
                                            We are unable to provide you with an
                                            offer at this point of time. Don't
                                            worry, a RedBuyers advisor will get
                                            in touch with you within 24 hours.
                                        </h4>
                                        <h4 class="text-dark font-weight-bold">
                                            Thank you for choosing RedBuyers.
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="new_selling_option">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="new_selling_option_title">
                                <h3>Your Selling Options with RedBuyers</h3>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="new_selling_option_box">
                                <div class="new_selling_option_box_image">
                                    <img
                                        src="/valuation/final_offer/image/so1.png"
                                        class="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div class="new_selling_option_box_content">
                                    <div
                                        class="new_selling_option_box_content_first"
                                    >
                                        <span>Sell to RedBuyers</span>
                                        <strong>Benefits:</strong>
                                        <ul>
                                            <li>
                                                Get A Cash Offer and Get Paid
                                            </li>
                                            <li>Skip Showings & Repairs</li>
                                            <li>Move On Your Schedule</li>
                                        </ul>
                                        <div
                                            class="new_selling_option_box_content_first_button"
                                        >
                                            <a
                                                href="javascript:void(0)"
                                                @click="
                                                    sell_to_redbuyers_presentation_page
                                                "
                                                >Get My Cash Offer Price</a
                                            >
                                            <a href="javascript:void(0)"></a>
                                        </div>
                                    </div>
                                    <div
                                        class="new_selling_option_box_content_second"
                                    >
                                        <span>What’s Next ?</span>
                                        <ul>
                                            <li>Show us your home</li>
                                            <li>Finalize the cash offer</li>
                                            <li>Sign the documents</li>
                                            <li>Close and get paid</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="new_selling_option_box">
                                <div
                                    class="new_selling_option_box_image top-adjust"
                                >
                                    <img
                                        src="/valuation/final_offer/image/so2.png"
                                        class="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div class="new_selling_option_box_content">
                                    <div
                                        class="new_selling_option_box_content_first"
                                    >
                                        <span>List with RedBuyers</span>
                                        <strong>Benefits:</strong>
                                        <ul>
                                            <li>Dedicated Local Experts</li>
                                            <li>Technology-Driven Marketing</li>
                                            <li>Your Home Sold Guaranteed</li>
                                        </ul>
                                        <div
                                            class="new_selling_option_box_content_first_button"
                                        >
                                            <a
                                                href="javascript:void(0)"
                                                @click="
                                                    list_with_redbuyers_presentation_page
                                                "
                                                >Get My Sales Assurance Price</a
                                            >
                                            <a href="javascript:void(0)"></a>
                                        </div>
                                    </div>
                                    <div
                                        class="new_selling_option_box_content_second"
                                    >
                                        <span>What’s Next ?</span>
                                        <ul>
                                            <li>Show us your home</li>
                                            <li>
                                                List with us for a maximum price
                                            </li>
                                            <li>Close and get paid</li>
                                            <li>
                                                Get a cash offer, and get paid,
                                                if it doesn’t sell as expected
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="new_schedule_appointment">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-md-9 order-2 order-md-1">
                            <div class="new_schedule_appointment_content">
                                <h4>Schedule An Appointment</h4>
                                <p>
                                    A quick phone call to explain the whole
                                    process. We collect more information about
                                    your home and upgrades to provide an
                                    accurate price.
                                </p>
                                <a
                                    href="javascript:void(0)"
                                    @click="expertValuation"
                                    >Schedule an appointment</a
                                >
                            </div>
                        </div>
                        <div class="col-md-3 order-1 order-md-2">
                            <div class="new_schedule_appointment_image">
                                <img
                                    src="/valuation/final_offer/image/money.png"
                                    class="img-fluid"
                                    alt="money"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <new-offer-tabs
                :valuation="valuation"
                :selectedAddress="selectedAddress"
                :bedrooms="bedrooms"
                :bathrooms="bathrooms"
                :square_foot="square_foot"
                :home_style="home_style"
                :garage="garage"
                :extra_details="extra_details"
                :user_id="user_id"
            />
            <!-- <div class="new_into_offer">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="new_into_offer_title">
                                <h5>What Went Into Your Offer</h5>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="new_into_offer_box">
                                <div class="new_into_offer_box_button">
                                    <ul class="nav nav-pills" id="pills-tab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="pills-comparable_home_sales-tab" data-toggle="pill" href="#pills-comparable_home_sales" role="tab" aria-controls="pills-comparable_home_sales" aria-selected="true">Comparable home sales</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="pills-market_trends-tab" data-toggle="pill" href="#pills-market_trends" role="tab" aria-controls="pills-market_trends" aria-selected="false">Market Trends</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="pills-home_details-tab" data-toggle="pill" href="#pills-home_details" role="tab" aria-controls="pills-home_details" aria-selected="false">Home Details</a>
                                    </li>
                                    </ul>
                                </div>
                                <div class="new_into_offer_box_content">
                                    <div class="tab-content" id="pills-tabContent">
                                        <div class="tab-pane fade show active" id="pills-comparable_home_sales" role="tabpanel" aria-labelledby="pills-comparable_home_sales-tab">
                                            <div class="new_into_offer_box_content_box" v-if="valuationPropertiesAvailable">
                                                <div class="col-md-12">
                                                    <div class="row">
                                                        <div
                                                            @click="goToDetails(item)"
                                                            v-for="(item, index) in valuation.properties"
                                                            :key="'property-item-' + index"
                                                            v-if="(seeMore && index > 3) || index <= 3"
                                                            class="col-xl-3 col-lg-4 col-md-6 mb-4 mb-lg-4 mb-md-4"
                                                        >
                                                            <div class="new_property_card">
                                                                <div class="new_property_card_image">
                                                                    <img
                                                                        :src="getPropertyImage(item)"
                                                                        v-on:error="handleImageErrorSecond"
                                                                        class="img-fluid"
                                                                        style="height: 100%"
                                                                        alt="home"
                                                                    >
                                                                </div>
                                                                <div class="new_property_card_content">
                                                                <div class="new_property_card_title">
                                                                    <span>{{ item.address }}, {{ item.city }}, {{ item.property_details.County }}, {{ item.zip }}</span>
                                                                </div>
                                                                <div class="new_property_card_ame">
                                                                    <ul>
                                                                        <li>
                                                                            <span>
                                                                                <img
                                                                                    src="/valuation/final_offer/image/bed_new.png"
                                                                                    class="img-fluid"
                                                                                    alt="bed"
                                                                                >
                                                                            </span>
                                                                            {{ getBedrooms(item.bedrooms,item.property_details) }} Beds
                                                                        </li>
                                                                        <li>{{ item.bathrooms }} Baths</li>
                                                                        <li>
                                                                            <span>
                                                                                <img
                                                                                    src="/valuation/final_offer/image/garage_new.png"
                                                                                    class="img-fluid"
                                                                                    alt="garage"
                                                                                >
                                                                                </span>
                                                                                {{ item.property_details.Gar_spaces }} Garage
                                                                            </li>
                                                                        <li v-if="item.square_foot">
                                                                            {{ item.square_foot }} sq ft
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div class="new_property_card_p">
                                                                    <p>Sold price: $ {{ item.sold_price | numberWithCommas }}</p>
                                                                    <p>Sold date: {{ item.sold_date.split(" ")[0] | soldDateFilter }}</p>
                                                                    <span>List price: <small>$ {{ item.property_details["Lp_dol"] | numberWithCommas }}</small></span>
                                                                    <span>{{ daysDifference(item.property_details["Input_date"], item.property_details["Unavail_dt"]) }} days in market</span>
                                                                </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="new_into_offer_box_see_more">
                                                        <a href="javascript:void(0)" class="seemore" style="text-decoration: none;" @click="seeMore = !seeMore">{{ seeMore ? "See Less" : "See More" }}</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="pills-market_trends" role="tabpanel" aria-labelledby="pills-market_trends-tab">
                                            <h3>Trends in {{ selectedAddress }}</h3>
                                            <div class="chart-wrapper bg-light">
                                                <div class="row chart-info">
                                                    <div class="col-md-6 col-lg-5">
                                                        <div>
                                                            <div class="d-flex align-items-center">
                                                            <p class="mr-2 font-weight-bold text-black-50">
                                                                Median sale price
                                                            </p>
                                                            &nbsp;&nbsp;
                                                            <p class="text-primary font-weight-bold">
                                                                ${{ valuation.average | fixedPrice | numberWithCommas }}
                                                            </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-5">
                                                    </div>
                                                </div>
                                                <div class="chart-container">
                                                    <canvas id="market_trend_chart"></canvas>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="pills-home_details" role="tabpanel" aria-labelledby="pills-home_details-tab">
                                            <div class="home-details-tab__header border-bottom">
                                                <h3 class="text-primary">Home details</h3>
                                            </div>
                                            <table class="table table-bordered">
                                                <thead>
                                                <tr>
                                                    <th>Bedrooms</th>
                                                    <th>Bathrooms</th>
                                                    <th>Square footage</th>
                                                    <th>Style of home</th>
                                                    <th>Garage spaces</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                    <td>{{ bedrooms }}</td>
                                                    <td>{{ bathrooms }}</td>
                                                    <td>{{ square_foot }}</td>
                                                    <td>{{ home_style }}</td>
                                                    <td>{{ garage }}</td>
                                                    </tr>
                                                    <tr>
                                                    <th>Extra details</th>
                                                    <td colspan="4">{{ extra_details }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </template>
    </div>
</template>

<script>
import * as echarts from "echarts";
import ValuationFailed from "./Valuation_Failed.vue";
import NewOfferTabs from "./NewOfferTabs.vue";
export default {
    name: "PropertyValuationFinalOffer",
    props: {
        user_id: {
            default: "",
        },
        user_id: "",
    },
    data() {
        return {
            selectedCity: "Toronto",
            selectedAddress: "",
            selectedAddressShort: "",
            name: "",
            email: "",
            phone: "",
            propertyType: "N.A",
            valuation_property_unit: "",
            basement: "No",
            bedrooms: 0,
            bathrooms: 0,
            square_foot: 0,
            home_style: "N.A",
            garage: 0,
            extra_details: "No details available",
            valuation: {
                min: 0,
                average: 0,
                max: 0,
                properties: [],
                idx_properties: [],
            },
            utm_source: "RedBuyers",
            utm_medium: "redbuyers.com",
            utm_campaign: "IN_HOUSE",
            utm_id: "REDBUYERS",
            utm_content: "Selling Options with RedBuyers",
            zip_code: "",
            latitude: "",
            longitude: "",
            seeMore: false,
            isLoading: false,
            fullPage: true,
            userEmail: "",
            userPassword: "",
            alertClass: "",
            alertMessage: "",
            valuation_property_finshed_basement_type: "",
        };
    },
    components: {
        "valuation-failed": ValuationFailed,
        "new-offer-tabs": NewOfferTabs,
    },
    mounted() {
        if (sessionStorage.getItem("valuation_city")) {
            this.selectedCity = sessionStorage.getItem("valuation_city");
        }
        if (sessionStorage.getItem("valuation_address")) {
            this.selectedAddress = sessionStorage.getItem("valuation_address");
        }
        if (sessionStorage.getItem("valuation_address_short")) {
            this.selectedAddressShort = sessionStorage.getItem(
                "valuation_address_short"
            );
        }
        if (sessionStorage.getItem("valuation_zip_code")) {
            this.zip_code = sessionStorage.getItem("valuation_zip_code");
        }
        if (sessionStorage.getItem("valuation_latitude")) {
            this.latitude = sessionStorage.getItem("valuation_latitude");
        }
        if (sessionStorage.getItem("valuation_longitude")) {
            this.longitude = sessionStorage.getItem("valuation_longitude");
        }
        //step-1 data
        if (sessionStorage.getItem("valuation_name")) {
            this.name = sessionStorage.getItem("valuation_name");
        }
        if (sessionStorage.getItem("valuation_email")) {
            this.email = sessionStorage.getItem("valuation_email");
        }
        if (sessionStorage.getItem("valuation_phone")) {
            this.phone = sessionStorage.getItem("valuation_phone");
        }
        //step-2 data
        if (sessionStorage.getItem("valuation_property_type")) {
            this.propertyType = sessionStorage.getItem(
                "valuation_property_type"
            );
        }
        if (sessionStorage.getItem("valuation_property_unit")) {
            this.valuation_property_unit = sessionStorage.getItem(
                "valuation_property_unit"
            );
        }
        //step-4 data
        if (sessionStorage.getItem("valuation_basement_present")) {
            this.basement = sessionStorage.getItem(
                "valuation_basement_present"
            );
        }
        if (
            sessionStorage.getItem("valuation_property_finshed_basement_type")
        ) {
            this.valuation_property_finshed_basement_type =
                sessionStorage.getItem(
                    "valuation_property_finshed_basement_type"
                );
        }
        //step-7 data
        if (sessionStorage.getItem("valuation_bed")) {
            this.bedrooms = sessionStorage.getItem("valuation_bed");
        }
        if (sessionStorage.getItem("valuation_bath")) {
            this.bathrooms = sessionStorage.getItem("valuation_bath");
        }
        if (sessionStorage.getItem("valuation_square_foot")) {
            this.square_foot = sessionStorage.getItem("valuation_square_foot");
        }
        if (sessionStorage.getItem("valuation_home_style")) {
            this.home_style = sessionStorage.getItem("valuation_home_style");
        }
        if (sessionStorage.getItem("valuation_garage")) {
            this.garage = sessionStorage.getItem("valuation_garage");
        }
        if (sessionStorage.getItem("valuation_comment")) {
            this.extra_details = sessionStorage.getItem("valuation_comment");
        }
        //other
        if (sessionStorage.getItem("valuation_utm_source")) {
            this.utm_source = sessionStorage.getItem("valuation_utm_source");
        }
        if (sessionStorage.getItem("valuation_utm_medium")) {
            this.utm_medium = sessionStorage.getItem("valuation_utm_medium");
        }
        if (sessionStorage.getItem("valuation_utm_campaign")) {
            this.utm_campaign = sessionStorage.getItem(
                "valuation_utm_campaign"
            );
        }
        if (sessionStorage.getItem("valuation_utm_id")) {
            this.utm_id = sessionStorage.getItem("valuation_utm_id");
        }
        if (sessionStorage.getItem("valuation_utm_content")) {
            this.utm_content = sessionStorage.getItem("valuation_utm_content");
        }
        // this.getInstantValuation();
        if (sessionStorage.getItem("valuation_data")) {
            let localValuation = JSON.parse(
                sessionStorage.getItem("valuation_data")
            );
            if (
                localValuation.min &&
                localValuation.max &&
                localValuation.average
            ) {
                this.valuation = localValuation;
                setTimeout(() => {
                    this.setupMarketTrend();
                }, 0);
            } else {
                this.getValuation();
            }
        } else {
            this.getValuation();
        }
    },
    beforeDestroy() {
        if (sessionStorage.getItem("valuation_data")) {
            sessionStorage.removeItem("valuation_data");
        }
    },
    filters: {
        numberWithCommas(x) {
            let val = x.toString().replace(".00", "");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        fixedPrice(val) {
            if (val) {
                let price = val.toFixed();
                if (price) {
                    return price;
                } else {
                    return val;
                }
            } else {
                return val;
            }
        },
        soldDateFilter(val) {
            if (val) {
                return moment(val).format("MMM Do YYYY");
            } else {
                return val;
            }
        },
    },
    computed: {
        valuationGenerated() {
            if (
                this.valuation.min == 0 &&
                this.valuation.max == 0 &&
                this.valuation.average == 0 &&
                !this.isLoading
            ) {
                return false;
            }
            return true;
        },
        valuationPropertiesAvailable() {
            if (
                this.valuation.properties &&
                this.valuation.properties.length == 0
            ) {
                return false;
            }
            return true;
        },
        marketStats() {
            if (
                this.valuation.properties &&
                this.valuation.properties.length > 0
            ) {
                let properties = [...this.valuation.properties];
                let stats_arr = [];
                for (let i = 0; i < properties.length; i++) {
                    stats_arr.push({
                        sold_date: properties[i].sold_date,
                        sold_price: properties[i].sold_price,
                        distance: properties[i].distance,
                    });
                }
                if (stats_arr.length > 0) {
                    stats_arr.sort(
                        (a, b) => new Date(b.sold_date) - new Date(a.sold_date)
                    );
                }
                return stats_arr;
            } else {
                return "No statistical data available";
            }
        },
        cashOfferValuation() {
            let minPrice = 0;
            let maxPrice = 0;
            let avgPrice = 0;
            if (this.valuation.min) {
                minPrice = this.valuation.min;
            }
            if (this.valuation.max) {
                maxPrice = this.valuation.max;
            }
            if (this.valuation.average) {
                avgPrice = this.valuation.average;
            }

            return {
                min: minPrice,
                max: maxPrice,
                average: avgPrice,
            };
        },
        get_sell_option_price() {
            let discounted_price = "0";
            let total_discounted = "0";
            if (this.valuation.average) {
                discounted_price = (this.valuation.average * 15) / 100;
                total_discounted = this.valuation.average - discounted_price;
            }
            return {
                list_amount: discounted_price,
                sell_amount: total_discounted,
            };
        },
    },
    methods: {
        handleImageError(event) {
            event.preventDefault();
            event.target.src = "/images/empty.png";
        },
        handleImageErrorSecond(event, url) {
            event.preventDefault();
            if (event.target.src.match(/\/\//g).length === 2) {
                const splitByProperties =
                    event.target.src.split("/soldProperties");
                const updated_url = splitByProperties.join("soldProperties");
                event.target.src = updated_url;
            } else {
                event.target.src = "/assets/images/no-image-available.png";
            }
        },
        goBack() {
            window.location.href = "/properties/valuation/submit/data/step-8";
        },
        goHome() {
            window.location.href = "/";
        },
        backUpOffer() {
            window.location.href = "/properties/valuation/submit/data/step-10";
        },
        contactRedBuyers() {
            window.location.href = "/contact-us";
        },
        getMyCashOffer() {
            window.location.href = "/presentation-get-cash-offer";
        },
        getInstantValuation() {
            this.isLoading = true;
            axios
                .get(
                    `https://valuation.santhoshmathew.com/api/v1/get-home-value-estimation-new?address=${this.selectedAddressShort}&bedrooms=${this.bedrooms}&bathrooms=${this.bathrooms}&type=${this.propertyType}&zip_code=${this.zip_code}&latitude=${this.latitude}&longitude=${this.longitude}`
                )
                .then((response) => {
                    let responseData = JSON.parse(
                        JSON.stringify(response.data)
                    );
                    this.valuation = responseData.data;
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally((result) => {
                    this.isLoading = false;
                    this.getValuation();
                });
        },
        roundHomeValue(value) {
            const remainder = value % 1000;
            if (remainder >= 500) {
                return value + (1000 - remainder); // round up
            } else {
                return value - remainder; // round down
            }
        },
        getValuation() {
            const formData = new FormData();
            formData.append("address", this.selectedAddress);
            formData.append("address_short", this.selectedAddressShort);
            formData.append("name", this.name);
            formData.append("email", this.email);
            formData.append("phone", this.phone);

            formData.append("type", this.propertyType);
            formData.append(
                "valuation_property_unit",
                this.valuation_property_unit
            );

            formData.append("basement", this.basement);
            formData.append(
                "valuation_property_finshed_basement_type",
                this.valuation_property_finshed_basement_type
            );

            formData.append("bedrooms", this.bedrooms);
            formData.append("bathrooms", this.bathrooms);
            formData.append("square_foot", this.square_foot);
            formData.append("style", this.home_style);
            formData.append("garage", this.garage);
            formData.append("extra_info", this.extra_details);

            // Additional Parameters
            formData.append("zip_code", this.zip_code);
            formData.append("latitude", this.latitude);
            formData.append("longitude", this.longitude);
            formData.append("offer_type", "cash");
            formData.append("valuation_city", this.selectedCity);

            this.isLoading = true;

            axios
                .get("https://api.bluebrickglobal.com/api/home-valuation", {
                    params: {
                        name: "test",
                        email: "test@gmail.com",
                        phone: "82091928392",
                        bedrooms: this.bedrooms,
                        bathrooms: this.bathrooms,
                        garage: this.garage,
                        style: this.home_style,
                        square_footage: this.square_foot,
                        address: this.selectedAddress,
                        city: this.selectedCity,
                        zip_code: this.zip_code,
                        latitude: this.latitude,
                        longitude: this.longitude,
                        basement: this.basement,
                        offer_type: "cash",
                        type: this.propertyType,
                        extra_info: this.extra_details,
                        valuation_property_finshed_basement_type: "Unfinished",
                    },
                })
                .then((response) => {
                    let responseData = JSON.parse(
                        JSON.stringify(response.data)
                    );
                    const Valuation = {
                        average: this.roundHomeValue(responseData.average),
                        min: responseData.min,
                        max: responseData.max,
                        properties: responseData.properties,
                    };
                    this.valuation = Valuation;
                    sessionStorage.setItem(
                        "valuation_data",
                        JSON.stringify(Valuation)
                    );
                    this.getIdxProperties();
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally((result) => {
                    this.isLoading = false;
                    if (sessionStorage.getItem("campaign_success")) {
                        let url = sessionStorage.getItem("campaign_success");
                        console.log("url", url);
                        // sessionStorage.removeItem('campaign_success');
                        const anchorTag = document.createElement("a");
                        anchorTag.setAttribute("href", url);
                        anchorTag.setAttribute("target", "_blank");
                        anchorTag.setAttribute("id", "success_page_link");
                        document.body.appendChild(anchorTag);
                        document.getElementById("success_page_link").click();
                        document.getElementById("success_page_link").remove();
                    }
                    setTimeout(() => {
                        this.setupMarketTrend();
                    }, 0);
                });
        },
        getIdxProperties() {
            const url = new URL(
                "https://valuation.santhoshmathew.com/api/v1/get-idx-home-in-home-valuation"
            );
            url.searchParams.append("address", this.selectedAddress);
            url.searchParams.append("bedrooms", this.bedrooms);
            url.searchParams.append("bathrooms", this.bathrooms);
            url.searchParams.append("garage", this.garage);
            url.searchParams.append("type", this.propertyType);
            url.searchParams.append("city", this.selectedCity);
            url.searchParams.append("latitude", this.latitude);
            url.searchParams.append("longitude", this.longitude);

            axios.get(url).then((response) => {
                this.valuation = {
                    ...this.valuation,
                    idx_properties: response.data.data,
                };
                sessionStorage.setItem(
                    "valuation_data",
                    JSON.stringify(this.valuation)
                );
            });
        },
        registerValuationMembership() {
            const formData = new FormData();
            formData.append("name", this.name);
            formData.append("email", this.userEmail);
            formData.append("password", this.userPassword);
            formData.append("phone", this.phone);

            axios
                .post("/idx-listings/valuation/membership", formData)
                .then((response) => {
                    this.alertClass = "success";
                    this.alertMessage = response.data.message;
                })
                .catch((error) => {
                    this.alertClass = "danger";
                    this.alertMessage = error.response.data.error;
                })
                .finally((result) => {
                    setTimeout(() => {
                        if (this.alertClass == "success") {
                            this.userEmail = this.email;
                            this.userPassword = "";
                            this.$v.$reset();
                            this.alertClass = "";
                            this.alertMessage = "";
                            document.getElementById("closeForm").click();
                        }
                    }, 3000);
                });
        },
        getPropertyImage(item) {
            return item?.photos?.length > 0
                ? item.photos[0]
                : "/images/empty.png";
        },
        setupMarketTrend() {
            let chartDom = document.getElementById("market_trend_chart");
            let myChart = echarts.init(chartDom);
            let option;

            let xAxisData = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
            let yAxisData = [150, 230, 224, 218, 135, 147, 260];

            if (
                this.valuation.properties &&
                this.valuation.properties.length > 0
            ) {
                let properties = [...this.valuation.properties];
                let stats_arr = [];
                for (let i = 0; i < properties.length; i++) {
                    stats_arr.push({
                        sold_date: properties[i].sold_date,
                        sold_price: properties[i].sold_price,
                        distance: properties[i].distance,
                    });
                }
                if (stats_arr.length > 0) {
                    stats_arr.sort(
                        (a, b) => new Date(a.sold_date) - new Date(b.sold_date)
                    );
                    let temp_x_axis_data = [];
                    let temp_y_axis_data = [];
                    for (let j = 0; j < stats_arr.length; j++) {
                        temp_x_axis_data[j] = moment(
                            stats_arr[j].sold_date
                        ).format("YYYY-MM-DD");
                        temp_y_axis_data[j] = stats_arr[j].sold_price;
                    }
                    xAxisData = [...temp_x_axis_data];
                    yAxisData = [...temp_y_axis_data];
                }
            }

            option = {
                xAxis: {
                    type: "category",
                    data: xAxisData,
                },
                tooltip: {
                    trigger: "item",
                    axisPointer: {
                        type: "cross",
                        crossStyle: {
                            type: "solid",
                        },
                    },
                    formatter: (params) => {
                        return `
                    Sold at: <br />
                    ${params.value}
                    `;
                    },
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        data: yAxisData,
                        type: "line",
                        showSymbol: true,
                        triggerLineEvent: true,
                    },
                ],
            };

            myChart.on("mouseover", function (params) {
                if (params.componentSubType == "line") {
                    tooltipDisplay = params.seriesName;
                }
            });

            myChart.on("mouseout", function (params) {
                tooltipDisplay = "";
            });

            myChart.resize();
            option && myChart.setOption(option, true);
        },
        expertValuation() {
            window.location.href = `/schedule/appointment`;
        },
        list_with_redbuyers_presentation_page() {
            const formData = new FormData();
            formData.append("utm_id", this.utm_id);
            formData.append("utm_source", this.utm_source);
            formData.append("utm_medium", this.utm_medium);
            formData.append("utm_campaign", this.utm_campaign);
            formData.append("utm_content", this.utm_content);

            formData.append("address", this.selectedAddress);
            formData.append("name", this.name);
            formData.append("email", this.email);
            formData.append("phone", this.phone);

            formData.append("type", this.propertyType);
            formData.append(
                "valuation_property_unit",
                this.valuation_property_unit
            );

            formData.append("basement", this.basement);
            formData.append(
                "valuation_property_finshed_basement_type",
                this.valuation_property_finshed_basement_type
            );

            formData.append(
                "offered_price",
                this.get_sell_option_price.list_amount
            );
            formData.append("offer_type", "List with RedBuyers");

            formData.append("bedrooms", this.bedrooms);
            formData.append("bathrooms", this.bathrooms);
            formData.append("square_foot", this.square_foot);
            formData.append("home_style", this.home_style);
            formData.append("garage", this.garage);
            formData.append(
                "comment",
                this.utm_content + " | " + this.extra_details
            );

            axios
                .post("/direct-leads/submit-leads", formData)
                .then((response) => {
                    console.log(response.data);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally((result) => {
                    window.location.href = `/list-with-redbuyers-presentation`;
                });
        },
        sell_to_redbuyers_presentation_page() {
            const formData = new FormData();
            formData.append("utm_id", this.utm_id);
            formData.append("utm_source", this.utm_source);
            formData.append("utm_medium", this.utm_medium);
            formData.append("utm_campaign", this.utm_campaign);
            formData.append("utm_content", this.utm_content);

            formData.append("address", this.selectedAddress);
            formData.append("name", this.name);
            formData.append("email", this.email);
            formData.append("phone", this.phone);

            formData.append("type", this.propertyType);
            formData.append(
                "valuation_property_unit",
                this.valuation_property_unit
            );

            formData.append("basement", this.basement);
            formData.append(
                "valuation_property_finshed_basement_type",
                this.valuation_property_finshed_basement_type
            );

            formData.append(
                "offered_price",
                this.get_sell_option_price.sell_amount
            );
            formData.append("offer_type", "Sell to RedBuyers");

            formData.append("bedrooms", this.bedrooms);
            formData.append("bathrooms", this.bathrooms);
            formData.append("square_foot", this.square_foot);
            formData.append("home_style", this.home_style);
            formData.append("garage", this.garage);
            formData.append(
                "comment",
                this.utm_content + " | " + this.extra_details
            );

            axios
                .post("/direct-leads/submit-leads", formData)
                .then((response) => {
                    console.log(response.data);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally((result) => {
                    window.location.href = `/sell-to-redbuyers-presentation`;
                });
        },
        goToDetails(value) {
            window.location.href =
                "/idx-listings/sold/properties/" +
                this.convertToSlug(
                    value["address"] +
                        ", " +
                        value["city"] +
                        ", " +
                        value["property_details"]["Area"] +
                        ", " +
                        value["property_details"]["Zip"] +
                        ", " +
                        value["property_details"]["County"]
                ) +
                "/" +
                value["id"];
        },
        convertToSlug(val) {
            return val
                .toLowerCase()
                .replace(/[^\w ]+/g, "")
                .replace(/ +/g, "-");
        },
        registerMembership() {
            this.$v.$touch();
            if (this.$v.userEmail.$error || this.$v.userPassword.$error) {
                return false;
            } else {
                this.registerValuationMembership();
            }
        },
        daysDifference(startDate, endDate) {
            let start = moment(startDate);
            let end = moment(endDate);
            return end.diff(start, "days");
        },
        getBedrooms(bedrooms, allDetails = null) {
            if (allDetails !== null) {
                let property_details = allDetails;
                let bedroom = "";
                if (property_details["Br"]) {
                    bedroom = bedroom + property_details["Br"];
                    if (property_details["Br_plus"]) {
                        bedroom = bedroom + " + " + property_details["Br_plus"];
                    }
                }
                return bedroom;
            } else {
                return bedrooms;
            }
        },
    },
};
</script>

<style scoped>
#market_trend_chart {
    width: 1200px;
    height: 400px;
}
.new_property_card_image {
    height: 165px;
}
</style>
